// extracted by mini-css-extract-plugin
module.exports = {"background":"typography_background__nyo5E","container":"typography_container__GCMpC","identifier":"typography_identifier__e6W5w","showcase":"typography_showcase__OtEsY"};